import CloseIcon from "@mui/icons-material/Close";
import { Modal, CircularProgress } from "@mui/material";
import { VideoItem } from "../types/General";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  video: VideoItem | null;
  isLoading?: boolean;
}

export default function VideoPopup({ open, onClose, video, isLoading }: ModalProps) {
  return (
    <Modal className="modal video_modal" open={open} onClose={onClose}>
      <div className="modal-dialog modal-lg">
        <div className="modal-body">
          <div className="modal_title" style={{ paddingBottom: '10px' }}>
            <div>
                <h2 style={{ margin: 0 }}>{video?.title || "Video Tutorial"}</h2>
                {video?.createdAt && (
                    <span style={{ fontSize: '13px', color: '#888', display: 'block', marginTop: '4px' }}>
                        {new Date(video.createdAt).toLocaleDateString()}
                    </span>
                )}
            </div>
            <button type="button" className="btn-close" onClick={onClose} style={{ alignSelf: 'flex-start' }}>
              <CloseIcon />
            </button>
          </div>

          {isLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <div className="video_container">
                {video?.video ? (
                  <video
                    src={video.video}
                    controls
                    autoPlay
                    poster={video.thumbnail}
                    className="w-100"
                    style={{
                      borderRadius: "12px",
                      maxHeight: "350px",
                      width: "100%",
                      backgroundColor: "#000",
                    }}
                  >
                    <track kind="captions" label="Captions" default />
                  </video>
                ) : (
                  <p className="text-center py-5">No video available</p>
                )}
              </div>

              {video?.description && (
                <div className="video_desc mt_20">
                  <p>{video.description}</p>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
}
